export const SANTA_MEMBERS_APP_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
export const MEMBERS_ABOUT_APP_ID = '14dbef06-cc42-5583-32a7-3abd44da4908';
